module.exports = __webpack_public_path__ + "fonts/5e6a951071d6b8c35f8201fdf541c523.svg";